import { FC, Fragment, JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { AddRounded as AddRoundedIcon } from '@mui/icons-material';
//components
import SupplierTable from './SupplierTable';
// constant, styles, reducer, graphql
import { flexCenterBetween } from 'styles/commonComponentStyle';
import { ADD_NEW_TEXT, ADD_SUPPLIER_ROUTE, SUPPLIERS_TEXT } from 'constants/index';

const Supplier: FC = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{SUPPLIERS_TEXT}</Typography>
        <Button variant="contained" color="primary" onClick={() => navigate(ADD_SUPPLIER_ROUTE)}>
          <AddRoundedIcon />
          {ADD_NEW_TEXT}
        </Button>
      </Box>
      <SupplierTable />
    </Fragment>
  );
};

export default Supplier;
